import { render, staticRenderFns } from "./titleDetails.vue?vue&type=template&id=ef67f5b8&scoped=true&lang=pug&"
import script from "./titleDetails.vue?vue&type=script&lang=js&"
export * from "./titleDetails.vue?vue&type=script&lang=js&"
import style0 from "./titleDetails.vue?vue&type=style&index=0&id=ef67f5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef67f5b8",
  null
  
)

export default component.exports